"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LuxuryEstate = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var Tags_1 = require("../Tags");
var CardRequirements_1 = require("../CardRequirements");
var TileType_1 = require("../../TileType");
var LuxuryEstate = (function (_super) {
    __extends(LuxuryEstate, _super);
    function LuxuryEstate() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.LUXURY_ESTATE,
            cost: 12,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.MARS, Tags_1.Tags.BUILDING],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(7); }),
            metadata: {
                cardNumber: 'Pf21',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.titanium(1).slash().city().plus().greenery();
                }),
                description: 'Oxygen must be 7% or greater. Gain 1 titanium for each city tile and greenery tile you own.',
            },
        }) || this;
    }
    LuxuryEstate.prototype.play = function (player) {
        var count = player.getCitiesCount() + player.game.getSpaceCount(TileType_1.TileType.GREENERY, player);
        player.addResource(Resources_1.Resources.TITANIUM, count, { log: true });
        return undefined;
    };
    return LuxuryEstate;
}(Card_1.Card));
exports.LuxuryEstate = LuxuryEstate;
